import { Component, Input, OnInit } from '@angular/core';
import { SkeletonSizeBase } from '../../Models/SkeletonSizesBase';
import { Shape } from '../..';

@Component({
  selector: 'skc-avatar',
  templateUrl: './avatar.component.html',
  styleUrls: ['./avatar.component.less']
})
export class AvatarComponent extends SkeletonSizeBase implements OnInit {
  @Input('skc-show-img') showImg = true;
  @Input('skc-src-img') srcImg;
  @Input('skc-multi-lines') multiLines = true;
  @Input('skc-width-first-line') widthFirstLine = '100px';
  @Input('skc-width-second-line') widthSecondLine = '150px';
  @Input('skc-height-line') heightLine;
  @Input('skc-shape') shape = Shape.CIRCLE;
  @Input('skc-border-radius') borderRadius;
  avatarImgSrc = 'assets/img/avatar.svg';

  constructor() {
    super();
  }

  ngOnInit() {}
}
